import styled from 'styled-components'
import {FlexContainerStyleProps} from './IProps'

// -CONTAINER
export const FlexContainer = styled.div<FlexContainerStyleProps>`
display:  ${ ({ container }) => container
    ? 'flex'
    : 'block'
};
    /****** Container Props ********/
flex-direction: ${ ({ flexDirection }) => flexDirection
    ? flexDirection
    : 'row'
};
justify-content: ${ ({ justifyContent }) => justifyContent
    ? justifyContent
    : 'flex-start'
};
flex-wrap: ${ ({ flexWrap }) => flexWrap
    ? flexWrap
    : 'wrap'
};
align-items: ${ ({ alignItems }) => alignItems
    ? alignItems
    : 'stretch'
};
    /****** Child Props ********/
flex-grow: ${ ({ flexGrow }) => flexGrow
    ? flexGrow
    : 0
};
flex-shrink: ${ ({ flexShrink }) => flexShrink
    ? flexShrink
    : 1
};
flex-basis: ${ ({ flexBasis }) => flexBasis
    ? flexBasis
    : 'auto'
};
flex: ${ ({ flex }) => flex
    ? flex
    : '0 1 auto'
};
    /****** Common Layout Props ********/
padding: ${ ({ padding }) => padding
    ? padding
    : '0'
};
margin: ${ ({ margin }) => margin
    ? margin
    : '0'
};
width: ${ ({ width }) => width
    ? width
    : 'auto'
};
height: ${ ({ height }) => height
    ? height
    : 'auto'
};
min-width: ${ ({ minWidth }) => minWidth
    ? minWidth
    : 'none'
};
max-width: ${ ({ maxWidth }) => maxWidth
    ? maxWidth
    : 'none'
};
min-height: ${ ({ minHeight }) => minHeight
    ? minHeight
    : 'none'
};
max-height: ${ ({ maxHeight }) => maxHeight
    ? maxHeight
    : 'none'
};
background-color: ${ ({ bgColor }) => bgColor
    ? bgColor
    : 'none'
};
`
